<template>
<m-pageframe
    title="{organization_label}: API Keys"
>
<v-container
    fluid
>

    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
        <v-menu
            bottom
            offset-y
            slot="append-outer"
        >
            <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
            </template>
    
            <v-list>
                <v-list-item
                    v-on:click="onClickCreate()"
                >
                    <v-list-item-title>New Credentials...</v-list-item-title>
                </v-list-item>
            </v-list>

        </v-menu> 
    </v-text-field>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
    
        <template v-slot:item.time_create_date="{ item }">
            {{$rc.pretty(item.time_create,'date')}}
        </template>

         <template v-slot:item.time_last_modified_date="{ item }">
            {{$rc.pretty(item.time_last_modified,'date')}}
        </template>

        <template v-slot:item.action="{ item }">
           <v-menu 
            bottom 
            offset-y  
           >
           
           <template v-slot:activator="{ on }">
                
            <v-icon 
                v-on="on"
            >
                mdi-dots-vertical-circle-outline
            </v-icon>
                
           </template>
           
           <v-list>
            <v-list-item
                v-on:click="onClickEdit(item)"
            >
                <v-list-item-title>Edit...</v-list-item-title>
            </v-list-item>
            
            <v-divider/>

            <v-list-item
                v-on:click="onClickDelete(item)"
            >
                <v-list-item-title>Delete...</v-list-item-title>
            </v-list-item>

           </v-list>
           
           </v-menu> 
        </template>
    
    </v-data-table>

    <m-settings-organization-api-key-edit-dialog
        ref="edit-dialog"
        v-on:change="doUpdate"
    />

    
    <h2 style="margin-top: 15px">Quick Start Instructions</h2>

    All of the API endpoints that you have access to can be listed using the <code>/api/v1/external</code> endpoint.  Here is an example cURL command:

    <m-code-block>
        curl -u "[credential id]:[secret]" {{$rc.getAPIEndpoint('external', false)}}
    </m-code-block>

    You can limit the fields you receive using the <code>X-field-filter</code> header (you can specify multile instances of this header).  For example:

    <m-code-block>
        curl -u "[credential id]:[secret]" {{$rc.getAPIEndpoint('external', false)}} \<br/>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;--header "X-field-filter: organization_id" \<br/>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;--header "X-field-filter: label"<br/>
    </m-code-block>

    <b>Pagination</b>
    <p>
        When required, RedChirp will paginate results for you.  Pagination is handled via <a href="https://en.wikipedia.org/wiki/HATEOAS" target="_blank">HATEOS</a>.  When there is a next page there will be a <code>next_page</code> url in the links returned by the first page.
    </p>


</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');
export default {

    data() {
        return {
            full_text: null,
            headers: [
                { text: 'Credential Id', value: 'credential_id'},
                { text: 'Created (date)', value: 'time_create_date'},
                { text: 'Modified (date)', value: 'time_last_modified_date'},
                { text: 'Label', value: 'label'},
                { text: 'Organization', value: 'organization_label'},
                { text: 'Role (username)', value: 'employee_username'},
                { text: 'Role (first name)', value: 'employee_first_name'},
                { text: 'Role (last name)', value: 'employee_last_name'},
                { text: 'Action', value: 'action' },
            ],

            results: [],
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/external/api-keys',
            
                'params' : {
                        'organization_id': this.$route.params.organization_id,
                    },
            
                'on_success': (data) => {
                        this.results = data.results;
                    },
            
                'on_error': 'Unable to list API keys',
            });
        },
        
        onClickCreate()
        {
            this.$refs['edit-dialog'].showDialog(null);  
        },

        onClickEdit(item)
        {
            this.$refs['edit-dialog'].showDialog(item); 
        },

        onClickDelete(item)
        {
            this.$rc.confirm({
                'title': 'Delete API Key',
                'body': 'Are you sure that you want to delete the api key: '+item.label+'?<br/><br/>This can not be undone.',
                'btn_text_ok': 'Delete',
                'btn_text_cancel': 'Cancel',
                'on_ok': () => {
                    this.doDelete(item);
                },
            });
        },

        doDelete(item)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'DELETE: /api/v1/external/api-keys',
            
                'params' : {
                        'credential_id': item.credential_id,
                    },
            
                'on_success': (data) => {
                        this.results = data.results;
                        this.doUpdate();
                    },
            
                'on_error': 'Unable to delete API key',
            });
        },
    },

}
</script>

<style lang="scss" scoped>
</style>


        